export interface Asset {
	/**
	 * The asset's type
	 */
	assetType: AssetType;
	/**
	 * The asset's url
	 */
	assetUrl: string;
}

export enum AssetType {
	Image = 'Image',
	Media = 'Media',
	Document = 'Document',
	YouTube = 'YouTube',
}

/**
 * Image Dimension
 */
export interface AssetDimension {
	/**
	 * The label of image dimension
	 */
	Label: string;
	Width: number;
	Height: number;
}
